'use strict';
var aCallable = require('../internals/a-callable');
var isNullOrUndefined = require('../internals/is-null-or-undefined');

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/get-method.js
// module id = 980
// module chunks = 0